import { PageHeader } from '@/components/common/PageHeader';
import { PageMeta } from '@/components/common/PageMeta';
import { ContactPage } from '@/pages/Contact/data';
import { ContactSection } from '@/pages/Contact/sections/ContactSection';

export default function Contact() {
  return (
    <>
      <PageMeta title={ContactPage.title} description={ContactPage.description} />
      <PageHeader title={ContactPage.heading} description={ContactPage.description} />
      <ContactSection />
    </>
  );
}